import React from 'react';
import { buildClassName } from '../../../utils';
import { NavigationButtonBase } from './NavigationButtonBase';
import { DropdownArrow } from './DropdownArrow';
import { CrawlerDropdown } from './CrawlerDropdown';
import { DropdownMenu } from './DropdownMenu';
import { useDropdownNavigation } from './useDropdownNavigation';
import type { DropdownNavigationButton } from '../../../types';
import type { NavigationActionHandler, NavigationStyleOverrides } from '../../../types/base';
import styles from '../DesktopNavigation.module.scss';

interface NavigationButtonDropdownProps {
  item: DropdownNavigationButton;
  isExpanded: boolean;
  isCrawler: boolean;
  onMouseEnter: () => void;
  onClick: () => void;
  onAction?: NavigationActionHandler;
  showChevron?: boolean;
  styleOverrides?: NavigationStyleOverrides;
  testId?: string;
}

export const NavigationButtonDropdown = ({ 
  item, 
  isExpanded,
  isCrawler,
  onMouseEnter,
  onClick,
  onAction,
  showChevron = true,
  styleOverrides = {},
  testId,
}: NavigationButtonDropdownProps) => {
  const { expandedItems, handleItemClick, toggleExpandedItem } = useDropdownNavigation({
    onAction,
  });

  return (
    <div 
      className={buildClassName(styles.buttonContainer, styleOverrides.navButton)}
      onMouseEnter={onMouseEnter}
      data-testid={testId}
    >
      <NavigationButtonBase
        className={styleOverrides.navButton}
        isExpanded={isExpanded}
        onClick={onClick}
        aria-label={item.label}
        data-testid={item.testId}
      >
        {item.leftSection}
        {item.customTrigger || item.label}
        {item.rightSection}
        {showChevron && (
          <DropdownArrow isExpanded={isExpanded} />
        )}
      </NavigationButtonBase>
      {isExpanded && (
        isCrawler ? (
          <CrawlerDropdown item={item} />
        ) : (
          <DropdownMenu
            items={item.items}
            expandedItems={expandedItems}
            onToggleExpanded={toggleExpandedItem}
            onItemClick={handleItemClick}
            styleOverrides={styleOverrides}
          />
        )
      )}
    </div>
  );
}; 